// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DialogNotifyWindow_dialog__3aN94","dialogContent":"DialogNotifyWindow_dialogContent__1HuyG","dialogButton":"DialogNotifyWindow_dialogButton__1koWG"};